export default "__VITE_ASSET__81e381e9__"